@if (chartsCountSg() === 1) {
  <!-- In case that there is only one chart, we want to display it on whole
  widget, and to avoid calculations for grid layout, only one chart is displayed
  without any classes-->
  <atn-ds-chart [chart]="chartsSg()[0]" />
} @else {
  <div
    #donutChartsContainer
    class="donut-chart-grid-container"
    [style.--donut-chart--min-width]="minWidth"
    [style.--donut-chart--min-height]="minHeight"
    [style.--donut-charts--max-columns]="columnsCountSg()"
    [style.--donut-charts--rows]="rowsCountSg()"
    [style.--donut-chart--container-height]="containerHeightSg()"
  >
    @for (chart of chartsSg(); track $index) {
      <atn-ds-chart [chart]="chart" />
    }
  </div>
}
